// Sub-navigation entries for the Crypto workspace.
export const CRYPTO_TABS = [
  { to: '/crypto',            label: 'Overview',       end: true },
  { to: '/crypto/heatmap',    label: 'Heatmap' },
  { to: '/crypto/fear-greed', label: 'Fear & Greed' },
];
